var $0681f168c13d8f2a$exports = {};
$0681f168c13d8f2a$exports = {
  "dragDescriptionKeyboard": "S\xFCr\xFCklemeyi ba\u015Flatmak i\xE7in Enter'a bas\u0131n.",
  "dragDescriptionKeyboardAlt": "S\xFCr\xFCklemeyi ba\u015Flatmak i\xE7in Alt + Enter'a bas\u0131n.",
  "dragDescriptionLongPress": "S\xFCr\xFCklemeye ba\u015Flamak i\xE7in uzun bas\u0131n.",
  "dragDescriptionTouch": "S\xFCr\xFCklemeyi ba\u015Flatmak i\xE7in \xE7ift t\u0131klay\u0131n.",
  "dragDescriptionVirtual": "S\xFCr\xFCklemeyi ba\u015Flatmak i\xE7in t\u0131klay\u0131n.",
  "dragItem": function dragItem(args) {
    return "".concat(args.itemText, "\u2019i s\xFCr\xFCkle");
  },
  "dragSelectedItems": function dragSelectedItems(args, formatter) {
    return "S\xFCr\xFCkle ".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " se\xE7ili \xF6ge");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " se\xE7ili \xF6ge");
      }
    }));
  },
  "dragSelectedKeyboard": function dragSelectedKeyboard(args, formatter) {
    return "".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " se\xE7ilmi\u015F \xF6\u011Fe");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " se\xE7ilmi\u015F \xF6\u011Fe");
      }
    }), " \xF6\u011Fesini s\xFCr\xFCklemek i\xE7in Enter'a bas\u0131n.");
  },
  "dragSelectedKeyboardAlt": function dragSelectedKeyboardAlt(args, formatter) {
    return "".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " se\xE7ilmi\u015F \xF6\u011Fe");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " se\xE7ilmi\u015F \xF6\u011Fe");
      }
    }), " \xF6\u011Fesini s\xFCr\xFCklemek i\xE7in Alt + Enter tu\u015Funa bas\u0131n.");
  },
  "dragSelectedLongPress": function dragSelectedLongPress(args, formatter) {
    return "".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " se\xE7ilmi\u015F \xF6\u011Fe");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " se\xE7ilmi\u015F \xF6\u011Fe");
      }
    }), " \xF6\u011Fesini s\xFCr\xFCklemek i\xE7in uzun bas\u0131n.");
  },
  "dragStartedKeyboard": "S\xFCr\xFCkleme ba\u015Flat\u0131ld\u0131. Bir b\u0131rakma hedefine gitmek i\xE7in Tab\u2019a bas\u0131n, ard\u0131ndan b\u0131rakmak i\xE7in Enter\u2019a bas\u0131n veya iptal etmek i\xE7in Escape\u2019e bas\u0131n.",
  "dragStartedTouch": "S\xFCr\xFCkleme ba\u015Flat\u0131ld\u0131. Bir b\u0131rakma hedefine gidin, ard\u0131ndan b\u0131rakmak i\xE7in \xE7ift t\u0131klay\u0131n.",
  "dragStartedVirtual": "S\xFCr\xFCkleme ba\u015Flat\u0131ld\u0131. Bir b\u0131rakma hedefine gidin, ard\u0131ndan b\u0131rakmak i\xE7in Enter\u2019a t\u0131klay\u0131n veya bas\u0131n.",
  "dropCanceled": "B\u0131rakma iptal edildi.",
  "dropComplete": "B\u0131rakma tamamland\u0131.",
  "dropDescriptionKeyboard": "B\u0131rakmak i\xE7in Enter'a bas\u0131n. S\xFCr\xFCklemeyi iptal etmek i\xE7in Escape'e bas\u0131n.",
  "dropDescriptionTouch": "B\u0131rakmak i\xE7in \xE7ift t\u0131klay\u0131n.",
  "dropDescriptionVirtual": "B\u0131rakmak i\xE7in t\u0131klay\u0131n.",
  "dropIndicator": "b\u0131rakma g\xF6stergesi",
  "dropOnItem": function dropOnItem(args) {
    return "".concat(args.itemText, " \xFCzerine b\u0131rak");
  },
  "dropOnRoot": "B\u0131rak\u0131n",
  "endDragKeyboard": "S\xFCr\xFCkleme. S\xFCr\xFCklemeyi iptal etmek i\xE7in Enter'a bas\u0131n.",
  "endDragTouch": "S\xFCr\xFCkleme. S\xFCr\xFCklemeyi iptal etmek i\xE7in \xE7ift t\u0131klay\u0131n.",
  "endDragVirtual": "S\xFCr\xFCkleme. S\xFCr\xFCklemeyi iptal etmek i\xE7in t\u0131klay\u0131n.",
  "insertAfter": function insertAfter(args) {
    return "".concat(args.itemText, "\u2019den sonra gir");
  },
  "insertBefore": function insertBefore(args) {
    return "".concat(args.itemText, "\u2019den \xF6nce gir");
  },
  "insertBetween": function insertBetween(args) {
    return "".concat(args.beforeItemText, " ve ").concat(args.afterItemText, " aras\u0131na gir");
  }
};
export { $0681f168c13d8f2a$exports as default };